import { defineMessages } from 'react-intl';

export const BadgeTypes = Object.freeze({
  SHUFFLE: 'shuffle',
  CLEAN: 'clean',
  CLEAN_SHORT: 'cleanShort',
  EXPLICIT_SHORT: 'explicitShort',
  RADIO: 'radio',
  UNAVAILABLE: 'unavailable',
  COLLECTED: 'collected',
  TAKEOVER_MODES: 'takeoverModes',
  CURATED_MODES: 'curatedModes',
});

export const BadgeText = defineMessages({
  SHUFFLE: {
    id: 't.shuffle',
    defaultMessage: 'shuffle',
  },
  SHUFFLE_ON: {
    id: 't.shuffleOn',
    defaultMessage: 'shuffle included',
  },
  SHUFFLE_OFF: {
    id: 't.shuffleOff',
    defaultMessage: 'shuffle excluded',
  },
  CLEAN: {
    id: 't.clean',
    defaultMessage: 'clean',
  },
  CLEAN_SHORT: {
    id: 't.cleanShort',
    defaultMessage: 'c',
  },
  EXPLICIT_SHORT: {
    id: 't.explicitShort',
    defaultMessage: 'e',
  },
  RADIO: {
    id: 't.radio',
    defaultMessage: 'radio',
  },
  UNAVAILABLE: {
    id: 't.unavailable',
    defaultMessage: 'unavailable',
  },
  COLLECTED: {
    id: 't.collected',
    defaultMessage: 'collected',
  },
  ARTIST_MODES: {
    id: 't.artistModes',
    defaultMessage: 'Artist Modes',
  },
  CURATED_MODES: {
    id: 't.curatedModes',
    defaultMessage: 'Curated Modes',
  },
});
